function isObject(value) {
  const type = typeof value
  return value != null && (type === 'object' || type === 'function')
}
export default class EnumItem {
  _list = []
  _vmap = {}
  _kmap = {}
  constructor(params) {
    if (params) {
      const list = []
      const { _kmap, _vmap } = this
      Object.keys(params).forEach(key => {
        let value = 0
        let text = ''
        const item = params[key]
        if (isObject(item)) {
          value = item.value || 0
          text = item.text || ''
        } else {
          value = item
        }

        if (this._vmap[value]) {
          throw new Error('Duplicate Enum value!')
        }

        const ret = { key, value, text }
        _kmap[key] = ret
        _vmap[value] = ret
        this[key] = value
        list.push(ret)
      })
      this._list = list
    }
  }

  val2key(val) {
    const item = this._vmap[val] || {}
    return item.key || ''
  }

  val2text(val) {
    const item = this._vmap[val] || {}
    return item.text || ''
  }

  key2text(key) {
    const item = this._kmap[key] || {}
    return item.text || ''
  }

  key2val(key) {
    const item = this._kmap[key] || {}
    return item.value || 0
  }

  getList() {
    return [...this._list]
  }
}
